import React from 'react'

const CalendarViewSimGolf = ({}) => {
  return (
    <span className='calendar_view_sim_golf'>
      ToDo - calendar view
    </span>
  );
}

export default CalendarViewSimGolf